import { createFileRoute } from "@tanstack/react-router";
import { RecoveryEmail } from "@/features/auth";

const Route = createFileRoute("/_public/recovery-email/")({
  component: () => <RecoveryEmail />,
});

export { Route };
